import { render, staticRenderFns } from "./vs-form-geom.vue?vue&type=template&id=17503908"
import script from "./vs-form-geom.vue?vue&type=script&lang=js"
export * from "./vs-form-geom.vue?vue&type=script&lang=js"
import style0 from "./vs-form-geom.vue?vue&type=style&index=0&id=17503908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports